function ConversationInsightModel() {
    this.agent = "";
    this.conversation_date = "";
    this.duration = "";
    this.VS = 0;
    this.summary = "";
    this.agent_tag = "";
    this.client_tag = "";
    this.questions = { // Questions asked by agent and client
        agent: [],
        client: []
    };
    this.alerthits = [];
    this.topics = [];
    this.sentiment = [];
    this.trackers_detected = [];
    this.wpm = [];
    this.speaker_analysis = [];
    this.campaign_data = {};
};

export {
    ConversationInsightModel
}